<style scoped>
	.main-font {
		font-size: 8pt;
		font-family: Verdana, Geneva, Tahoma, sans-serif;
	}
	.toggle-button {
		color: rgb(5, 75, 99);
		cursor: pointer;
	}
	.table-cell {
		border: #6a8ccb 1px solid;
		border-collapse: collapse;
	}
	.table-cell-no-top {
		border-top: none;
	}
	.table-cell-no-left {
		border-left: none;
	}
	.footer {
		font-size: 7pt;
		color: gray;
	}
	.claim-graph {
		height: 255px;
	}
	.selected-tab {
		font-weight: bold;
		background-color: #ffe7a2;
	}
	.static-entry {
		user-select: none;
	}
	.tab-trapezoid {
		position: relative;
		background-color: #6a8ccb;
		color: white;
		font-size: 8pt;
		height: 24px;
		padding-top: 4px;
		text-align: center;
		user-select: none;
		width: 100%;
		z-index: 10 !important;

		clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%);
		cursor: pointer;
		transition: background-color 0.3s;
	}
	.tab-trapezoid-selected {
		background-color: rgb(54, 15, 226);
		z-index: 20 !important;
	}
	/* could probably do something with these overlaps
  and calculations, if this becomes a commonly used structure - I had
  to piece this together from a few css sources.
  I really think a different tab approach would be better, but this works for now.
  */
	.tab-overlap-middle {
		margin-left: -12px;
		margin-right: -25px;
		z-index: 15;
	}
	.tab-overlap-left {
		margin-right: -15px;
		z-index: 12;
	}
	.tab-overlap-right {
		margin-left: -25px;
		z-index: 12;
	}
</style>

<template>
	<div v-if="privilegeLevel === 0" class="container">
		<div class="row">
			<div class="col text-center">
				<h3>
					You do not have permissions to view the Claims Inspector gadget.
				</h3>
			</div>
		</div>
	</div>
	<div
		v-if="privilegeLevel > 0"
		class="position-relative"
		style="height: 175px"
	>
		<div
			v-if="isLoading"
			class="position-absolute top-50 start-50 translate-middle"
		>
			<LoadingSection :is-loading="isLoading"></LoadingSection>
		</div>

		<div v-else class="container main-font mt-1">
			<div class="row">
				<div
					class="col-12 toggle-button text-end cursor-pointer"
					@click="toggleView"
				>
					{{ viewLabel }}
				</div>
			</div>
			<div class="row mt-2 main-font" id="mainTable">
				<div class="col">
					<div class="row">
						<div class="col static-entry main-font">Unsubmitted</div>
						<div
							:class="[
								'col',
								'table-cell',
								'static-entry',
								selectedTab === 'Unsubmitted' &&
									viewCategory === 'C' &&
									'selected-tab',
							]"
							id="UnsubmittedCount"
							v-on:click="(e) => TableClick('Unsubmitted', 'C')"
						>
							{{
								viewMode == "P" ? countUnsubmittedPractice : countUnsubmitted
							}}
						</div>
						<div
							:class="[
								'col',
								'static-entry',
								'table-cell',
								'table-cell-no-left',
								selectedTab === 'Unsubmitted' &&
									viewCategory === 'T' &&
									'selected-tab',
							]"
							id="UnsubmittedTotal"
							v-on:click="(e) => TableClick('Unsubmitted', 'T')"
						>
							{{
								viewMode == "P"
									? prettyCurrency(totalUnsubmittedPractice)
									: prettyCurrency(totalUnsubmitted)
							}}
						</div>
					</div>
					<div class="row">
						<div class="col static-entry">Missing Insurance</div>
						<div
							:class="[
								'col',
								'static-entry',
								'table-cell',
								'table-cell-no-top',
								selectedTab === 'Missing Insurance' &&
									viewCategory === 'C' &&
									'selected-tab',
							]"
							id="MissingInsuranceCount"
							v-on:click="(e) => TableClick('Missing Insurance', 'C')"
						>
							{{ viewMode == "P" ? countMissingPractice : countMissing }}
						</div>
						<div
							:class="[
								'col',
								'static-entry',
								'table-cell',
								'table-cell-no-top',
								'table-cell-no-left',
								selectedTab === 'Missing Insurance' &&
									viewCategory === 'T' &&
									'selected-tab',
							]"
							id="MissingInsuranceTotal"
							v-on:click="(e) => TableClick('Missing Insurance', 'T')"
						>
							{{
								viewMode == "P"
									? prettyCurrency(totalMissingPractice)
									: prettyCurrency(totalMissing)
							}}
						</div>
					</div>
					<div class="row static-entry">
						<div class="col">Rejected</div>
						<div
							:class="[
								'col',
								'table-cell',
								'table-cell-no-top',
								selectedTab === 'Rejected' &&
									viewCategory === 'C' &&
									'selected-tab',
							]"
							id="RejectedCount"
							v-on:click="(e) => TableClick('Rejected', 'C')"
						>
							{{ viewMode == "P" ? countRejectedPractice : countRejected }}
						</div>
						<div
							:class="[
								'col',
								'table-cell',
								'table-cell-no-left',
								'table-cell-no-top',
								selectedTab === 'Rejected' &&
									viewCategory === 'T' &&
									'selected-tab',
							]"
							id="RejectedTotal"
							v-on:click="(e) => TableClick('Rejected', 'T')"
						>
							{{
								viewMode == "P"
									? prettyCurrency(totalRejectedPractice)
									: prettyCurrency(totalRejected)
							}}
						</div>
					</div>
				</div>
			</div>
			<hr class="border border-secondary border-1 w-100 mb-0 pb-0" />

			<div>
				<div class="row">
					<div class="col">
						<div class="claim-graph mt-0 pt-0" id="claimGraph"></div>
					</div>
				</div>
				<div class="row">
					<div class="col" style="margin-left: 10px">
						<div class="row g-0" id="chartTabRow">
							<div class="col-4 ps-0 pe-0">
								<div
									id="UnsubmittedTab"
									v-on:click="(e) => TabClick(0)"
									:class="[
										'tab-trapezoid',
										'tab-overlap-left',
										selectedTab === 'Unsubmitted' && 'tab-trapezoid-selected',
									]"
								>
									Unsubmitted
								</div>
							</div>
							<div class="col-4 ps-0 pe-0">
								<div
									id="MissingInsuranceTab"
									@click="(e) => TabClick(1)"
									:class="[
										'tab-trapezoid',
										'tab-overlap-middle',
										selectedTab === 'Missing Insurance' &&
											'tab-trapezoid-selected',
									]"
								>
									Missing Insurance
								</div>
							</div>
							<div class="col-4 ps-0 pe-0">
								<div
									id="RejectedTab"
									v-on:click="(e) => TabClick(2)"
									:class="[
										'tab-trapezoid',
										'tab-overlap-right',
										selectedTab === 'Rejected' && 'tab-trapezoid-selected',
									]"
								>
									Rejected
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row mt-1">
				<div class="col text-end align-end">
					<div class="footer">{{ lastLoaded }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { onMounted, ref, watch, computed } from "vue";
	import * as Highcharts from "highcharts";
	import Exporting from "highcharts/modules/exporting";
	import { ProviderDailyCounts } from "./ProviderDailyCounts";
	import { GadgetService } from "../../lib/Api/Gadget/GadgetService";
	import { prettyCurrency } from "../../lib/Formatting/Number";
	import OfflineExporting from "highcharts/modules/offline-exporting";
	import LoadingSection from "../../components/LoadingSection.vue";

	// GadgetService based on the currently logged in user
	const props = defineProps<{ privilege: number }>();

	const viewMode = ref<"P" | "M">("P");
	const viewCategory = ref<"T" | "C">("C"); // T or C, total or count
	const selectedTab = ref<"Unsubmitted" | "Missing Insurance" | "Rejected">(
		"Unsubmitted"
	);
	const lastLoaded = ref("");
	const claimsData = ref<ProviderDailyCounts[]>([]);
	const privilegeLevel = ref(props.privilege);

	// I'm assigning these to -1 to prevent recalulculating the values
	// The original design, and it might go back to it, was to calculate
	// values on when necessary.
	// After reworking the calc method, it was inditringuishable to
	// just calculate both, but I'm leaving it, don't hurt nothin',
	// might go back to it. I suppose it might still cut down on
	// needless event raise.
	const totalUnsubmitted = ref(0);
	const countUnsubmitted = ref(0);
	const totalMissing = ref(0);
	const countMissing = ref(0);
	const totalRejected = ref(0);
	const countRejected = ref(0);
	const totalUnsubmittedPractice = ref(0);
	const countUnsubmittedPractice = ref(0);
	const totalMissingPractice = ref(0);
	const countMissingPractice = ref(0);
	const totalRejectedPractice = ref(0);
	const countRejectedPractice = ref(0);
	const isLoading = ref(true);

	// chart
	const MainChart = ref<Highcharts.Chart | null>(null);
	// this is performed according to the HighCharts documentation - to align the x axis
	// seems like a lot, but it works - just using the date values skewed the chart and the axis
	const now = new Date();
	const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
	const days30 = today - 30 * 24 * 60 * 60 * 1000;
	const days60 = today - 60 * 24 * 60 * 60 * 1000;
	const tickPositions = [days60, days30, today];

	onMounted(async () => {
		// get provider data, if permissions allow
		if (privilegeLevel.value > 0) {
			await LoadLastLoadDate();
			await LoadProviderData();
			isLoading.value = false;
			setTimeout(() => {
				RenderChart();
			}, 200);
		}
	});

	async function TabClick(tab: number) {
		switch (tab) {
			case 1:
				selectedTab.value = "Missing Insurance";
				break;
			case 2:
				selectedTab.value = "Rejected";
				break;
			default:
				selectedTab.value = "Unsubmitted";
				break;
		}

		await RenderChart();
	}

	async function TableClick(
		tab: "Unsubmitted" | "Missing Insurance" | "Rejected",
		category: "T" | "C"
	) {
		selectedTab.value = tab;
		viewCategory.value = category;
		await RenderChart();
	}

	async function LoadLastLoadDate() {
		lastLoaded.value =
			"Date last loaded on " +
			((await GadgetService.GetLastLoadDate(2)) ?? "<unknown>");
	}

	function resetData() {
		totalUnsubmitted.value = 0;
		countUnsubmitted.value = 0;
		totalMissing.value = 0;
		countMissing.value = 0;
		totalRejected.value = 0;
		countRejected.value = 0;
		totalUnsubmittedPractice.value = 0;
		countUnsubmittedPractice.value = 0;
		totalMissingPractice.value = 0;
		countMissingPractice.value = 0;
		totalRejectedPractice.value = 0;
		countRejectedPractice.value = 0;
	}

	async function ProcessData() {

		// updating this to handle empty data
		const entries = claimsData.value.filter((x) => x.isProvider == true);
		let latestEntry = null;
		let latestEntryPractice = null;

		if (entries.length != 0) {
			// get the latest entry
			latestEntry = entries.reduce((latest, current) => {
				const latestDate = new Date(latest.countDate);
				const currentDate = new Date(current.countDate);
				return currentDate > latestDate ? current : latest;
			});
		} else {
			latestEntry = null;
			resetData();
		}

		// latest practice entries (will need to be aggregated)
		if (latestEntry !== null) {
			latestEntryPractice = claimsData.value.filter(
				(x) => x.countDate == latestEntry.countDate && x.isProvider == false
			);
		}

		if (latestEntryPractice !== null && latestEntryPractice.length > 0) {
			if (totalUnsubmittedPractice.value <= 0) {
				totalUnsubmittedPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.unsubmittedCharge,
					0
				);
			}

			if (countUnsubmittedPractice.value <= 0) {
				countUnsubmittedPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.unsubmittedCount,
					0
				);
			}

			if (totalMissingPractice.value <= 0) {
				totalMissingPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.missingInsuranceCharge,
					0
				);
			}
			if (countMissingPractice.value <= 0) {
				countMissingPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.missingInsuranceCount,
					0
				);
			}

			if (totalRejectedPractice.value <= 0) {
				totalRejectedPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.rejectedCharge,
					0
				);
			}
			if (countRejectedPractice.value <= 0) {
				countRejectedPractice.value = latestEntryPractice.reduce(
					(sum, x) => sum + x.rejectedCount,
					0
				);
			}
		}

		if (latestEntry) {
			if (totalUnsubmitted.value <= 0) {
				totalUnsubmitted.value = latestEntry.unsubmittedCharge;
			}
			if (countUnsubmitted.value <= 0) {
				countUnsubmitted.value = latestEntry.unsubmittedCount;
			}

			if (totalMissing.value <= 0) {
				totalMissing.value = latestEntry.missingInsuranceCharge;
			}
			if (countMissing.value <= 0) {
				countMissing.value = latestEntry.missingInsuranceCount;
			}

			if (totalRejected.value <= 0) {
				totalRejected.value = latestEntry.rejectedCharge;
			}
			if (countRejected.value <= 0) {
				countRejected.value = latestEntry.rejectedCount;
			}
		}
	}

	async function LoadProviderData() {
		claimsData.value =
			(await GadgetService.GetClaimsInspectorGadgetData(60)) ?? [];
		await ProcessData();
	}

	const viewLabel = computed(() =>
		viewMode.value === "P" ? "Practice Productivity" : "My Productivity"
	);

	const toggleView = () => {
		viewMode.value = viewMode.value === "P" ? "M" : "P";
		RenderChart();
	};

	// I originally did this as a generic function with a map to select the correct value
	// it was very slow and very hard to read
	// I suspect a future version of TS will address this,
	// I'm leaving this verbose for now - this is blink of an eye, the other took at least 5+ seconds
	// (maybe the data needs to be sorted? Regardless, there are no performance gains in it.)

	function FilterSelectedUnsubmitted() {
		const providerFiltered =
			viewMode.value === "P"
				? claimsData.value
				: claimsData.value.filter((x) => x.isProvider == true);

		return providerFiltered.reduce((chartData, x) => {
			const date = x.countDate;
			const value =
				viewCategory.value === "C" ? x.unsubmittedCount : x.unsubmittedCharge;
			chartData[date] = value;
			return chartData;
		}, {} as Record<string, number>);
	}

	function FilterSelectedMissingInsurance() {
		const providerFiltered =
			viewMode.value === "P"
				? claimsData.value
				: claimsData.value.filter((x) => x.isProvider == true);

		return providerFiltered.reduce((chartData, x) => {
			const date = x.countDate;
			chartData[date] =
				viewCategory.value === "C"
					? x.missingInsuranceCount
					: x.missingInsuranceCharge;
			return chartData;
		}, {} as Record<string, number>);
	}

	function FilterSelectedRejected() {
		const providerFiltered =
			viewMode.value === "P"
				? claimsData.value
				: claimsData.value.filter((x) => x.isProvider == true);

		return providerFiltered.reduce((chartData, x) => {
			const date = x.countDate;
			chartData[date] =
				viewCategory.value === "C" ? x.rejectedCount : x.rejectedCharge;
			return chartData;
		}, {} as Record<string, number>);
	}

	function FilterSelectedData() {
		let filtered;
		if (selectedTab.value == "Unsubmitted") {
			filtered = FilterSelectedUnsubmitted();
		}

		if (selectedTab.value == "Missing Insurance") {
			filtered = FilterSelectedMissingInsurance();
		}

		if (selectedTab.value == "Rejected") {
			filtered = FilterSelectedRejected();
		}

		if (!filtered) return null;

		return Object.entries(filtered).map(([dateStr, value]) => ({
			x: dateStr,
			y: value,
		}));
	}

	async function RenderChart() {
		const chartDiv = "claimGraph";
		const chartTitle: string = `${selectedTab.value} ${
			viewCategory.value === "T" ? "Totals" : "Count"
		}`;

		const seriesData = FilterSelectedData();

		let newChart = Highcharts.chart(
			chartDiv,
			{
				chart: { type: "line" },
				tooltip: {
					crosshairs: true,
					xDateFormat: "%Y-%m-%d",
					pointFormat: "<b>{point.y}</b> {series.name}",
				},

				title: {
					text: chartTitle,
					align: "center",
					style: {
						fontSize: "9pt",
						fontWeight: "bold",
					},
				},

				credits: {
					enabled: false,
				},

				yAxis: {
					title: {
						text: null,
					},
				},

				xAxis: {
					type: "datetime",
					tickPositions: tickPositions,
					labels: {
						formatter: function () {
							switch (this.value) {
								case days60:
									return "60 Days";
								case days30:
									return "30 Days";
								case today:
									return "Today";
								default:
									return "";
							}
						},
						style: {
							fontSize: "8pt",
							fontWeight: "bold",
						},
					},
					title: {
						text: null,
					},
				},

				exporting: {
					buttons: {
						contextButton: {
							align: "right",
							verticalAlign: "bottom",
						},
					},
					fallbackToExportServer: false,
				},

				navigation: {
					menuItemStyle: {
						fontSize: "0.7em",
					},
				},

				series: [
					{
						name: selectedTab.value,
						data: seriesData,
						color: "#fdd835",
						lineWidth: 3,
					},
				],

				legend: {
					enabled: false,
				},

				plotOptions: {
					series: {
						marker: {
							symbol: "circle",
							enabled: true,
							radius: 1.5,
							lineWidth: 1,
						},
					},
				},

				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								legend: {
									layout: "horizontal",
									align: "center",
									verticalAlign: "bottom",
								},
							},
						},
					],
				},
			}
			// end highchart construction
		);
		MainChart.value = newChart;
		await MainChart.value.redraw();
	}
</script>
